import { GlobalInformation } from './global-information.model';
import { VehicleCost } from './vehicle-cost.model.';
import { VehicleInformation } from './vehicle-information.model';

export class Comparison {
	globalInfo!: GlobalInformation;
	vehicleInfo!: VehicleInformation;
	vehicleCost!: VehicleCost;
	date: Date;
}
